import React from "react";
import "./styles.css";

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <div className="section">
        <div className="section-header">
          <h2>Privacy Policy</h2>
        </div>
        <div className="section-content">
          <p>
            This Privacy Policy describes how Lika World Academy ("We," "Us," or
            "Our") collects, uses, and protects the personal information of
            users ("You" or "Your") when you use our mobile application LWA
            ("the App") and associated services. We are committed to maintaining
            the privacy and security of your personal information and complying
            with applicable data protection laws. By using the Service, you
            agree to the collection and use of information in accordance with
            this Privacy Policy
          </p>
          <p>
            <h3>1. Information We Collect</h3>{" "}
            <p>
              {" "}
              When you use Lika World Academy, we may collect the following
              information:
              <ul>
                <li>
                  <strong>Primary Account Information:</strong> When you
                  register for an account in our mobile app, we will collect
                  your name, email address, and a password created by you. We
                  will use your email address to send you account related
                  notifications.
                </li>
                <br />
                <li>
                  We offer social login options through Google and Facebook. If
                  you choose either of these login options, we will access your
                  basic public profile information such as name and profile
                  picture from those services. We do not store your social login
                  credentials.
                </li>
              </ul>
            </p>
            <h3>2. How We Use Your Information</h3>{" "}
            <p>
              {" "}
              The information we collect, including Primary account data, is
              used solely for the following purposes:
            </p>{" "}
            <ul>
              <li>
                To authenticate your identity and provide personalized app
                features.
              </li>
              <li>To enhance and improve Lika World Academy.</li>
              <li>
                To analyze app usage patterns and make necessary improvements.
              </li>
              <li>To communicate important updates and promotions.</li>
            </ul>
            <h3>3. Privacy Policy for Distributed App </h3>
            <p>
              For users of our app who have their data uploaded to
              "https://api.newkameleon.bluepanda.pt," please note that this
              action is governed by a separate privacy policy, which you can
              find on our{" "}
              <a
                href="https://privacy-policy-test.vercel.app/privacy-policy-disturbed"
                target="_blank"
              >
                website
              </a>
              .
            </p>
            <h3>4. Data Sharing</h3>
            <p>
              We do not rent, sell, or share your personal information with
              third parties except as described in this Policy. We may disclose
              your information to vendors and service providers we rely on to
              operate our business and mobile app. We restrict their use of
              personal data and require them to keep it confidential.
            </p>
            <h3>5. Disclosure of Your Information</h3>{" "}
            <p>
              We may disclose your information if required to do so by law or in
              the good-faith belief that such action is necessary to comply with
              state and federal laws or respond to a court order, judicial or
              other government subpoena, or warrant.
            </p>{" "}
            <h3>6. Push Notifications</h3>
            <p>
              With your permission, we may send push notifications to your
              device to provide important updates about our service or for
              marketing purposes. You can unsubscribe from receiving these
              notifications at any time.
            </p>
            <h3>7. Security</h3>
            <p>
              We implement reasonable precautions and follow industry best
              practices to protect your personal information. Your personal
              information is contained behind secured networks and is only
              accessible by a limited number of persons who have special access
              rights to such systems and are required to keep the information
              confidential.
            </p>
            <h3>8. Data Retention and Deletion </h3>
            <p>
              We retain personal information for as long as necessary to provide
              you services and fulfill the purposes outlined in this policy
              unless otherwise required by law. You have the right to request
              deletion of your account or correction of any information we hold
              about you at any time. To do so, please contact us at
              adminstration@bluepanda.pt or through our deletion request form at
              our mobile app Lika World Academy on Contact Form Menu.
            </p>
            <p>
              We will acknowledge receipt of your request within 72 hours and
              aim to fully address it within 30 days to the extent permitted by
              any legal or regulatory obligations. Some information may remain
              in backup records but we aim to de-identify them within 180 days.
            </p>
            <h3>9. In-App Purchases</h3>
            <p>
              Our app uses Google Play Billing and Apple In-App Purchase as
              payment methods to purchase virtual items within the app. We
              adhere to these platforms' privacy policies regarding any data
              collected during checkout procedures.
            </p>
            <h3>10. Your Choices</h3>
            <p>
              You can review and update your account information within the app
              settings. If you have any questions or concerns about your data,
              please contact us at adminstration@bluepanda.pt.
            </p>
            <h3>11. Changes to This Privacy Policy</h3>
            <p>
              We may update this Privacy Policy periodically to reflect changes
              in our practices or for legal reasons. Significant updates will be
              communicated through the app or via email.
            </p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
